import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { query, where, getDocs, collection } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from 'js-cookie';
//page links  

import './footer.css';
import { GrUserWorker } from "react-icons/gr";
import { MdOutlineWorkOutline } from "react-icons/md";
import { BsPersonWorkspace } from "react-icons/bs";
import GooglePlayIcon from '../assets/android-app_v1.png';
import Appstore from '../assets/ios-app_v1.png';
import { BsInstagram } from 'react-icons/bs';
import { BsFacebook } from 'react-icons/bs';
import { BsYoutube } from 'react-icons/bs';
import { BsLinkedin } from 'react-icons/bs';
import { BsX } from 'react-icons/bs';
export default function Footertearms() {
  const navigate = useNavigate();
  const location = useLocation();
  const [Jobtasks, setJobtasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [rowCounts, setRowCounts] = useState({
    users: 0,
    postdata: 0,
    companys: 0,
    total: 0
  });

  //Jobtasks 
  useEffect(() => {
    const fetchJobtasks = async () => {
      try {
        // Fetch job posts
        const postQuery = query(
          collection(db, "postdata"),
          where("status", "==", true)
        );
        const postSnapshot = await getDocs(postQuery);
        const postCount = postSnapshot.size;

        // Fetch users
        const userQuery = query(
          collection(db, "users"),
          where("status", "==", true)
        );
        const userSnapshot = await getDocs(userQuery);
        const userCount = userSnapshot.size;

        const editor = userSnapshot.docs[0]
          ? { id: userSnapshot.docs[0].id, ...userSnapshot.docs[0].data() }
          : null;

        // Fetch companies
        const companyQuery = query(
          collection(db, "companys"),
          where("status", "==", true)
        );
        const companySnapshot = await getDocs(companyQuery);
        const companyCount = companySnapshot.size;

        const company = companySnapshot.docs[0]
          ? { id: companySnapshot.docs[0].id, ...companySnapshot.docs[0].data() }
          : null;

        // Combine data
        const JobtasksList = postSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          editor,
          company,
        }));

        // Update states
        setJobtasks(JobtasksList);
        setRowCounts({
          users: userCount,
          postdata: postCount,
          companys: companyCount,
          total: userCount + postCount + companyCount
        });

      } catch (error) {
        console.error("Error fetching job tasks:", error);
      } finally {
        setIsLoading(false);
      }
    };

    //fetchJobtasks();
  }, []);


  return (
    <div className="footer-body">
 
      <div className="tearms_body">
        <div className="container_size">

          {/* <table className='tearms_table'>

            <tr>
              <td>
                <div className="button-ui2 tab-counter"><GrUserWorker className='icon' /> Editor  <b>{rowCounts.users}</b></div>
              </td>

              <td>
                <div className="button-ui2 tab-counter"><MdOutlineWorkOutline className='icon' />Companys <b>{rowCounts.companys}</b></div>
              </td>

              <td>
                <div className="button-ui2 tab-counter"><BsPersonWorkspace className='icon' />Job Task <b>{rowCounts.postdata}</b></div>
              </td>
            </tr>

          </table> */}

<div className='rights-div'> &#169; <b>EditorTask - Kang Technology</b> {new Date().getFullYear()} All rights reserved </div>
          <div className="tearms_div">
            <div className='trademark-div'><a  className="tab-link" href="https://kang.in" _target><b>Kang Technology</b></a> All trademarks are the property of their respective owners 
              <br/><a>Update 1/04/2025</a>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
